import update from 'immutability-helper'
import fetch from '../helpers/command'

export async function LoadPreferences({preferences, updateState}) {

  if (!preferences.pendingRefresh) return

  updateState({preferences: {loaded: {$set: false}}})

  const [properties] = await fetch('public', 'preferences')()

  updateState({preferences: {
    properties: {$set: initializeProperties(properties)},
    loaded: {$set: true},
    pendingRefresh: {$set: false}
  }})

}

function initializeProperties (initial) {

  let properties = initial

  if (!properties.notifications)
    properties = update(properties, {notifications: {$set: {}}})

  return properties

}
